import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTermsAndConditionsController } from './useTermsAndConditionsController';
interface TermsAndConditionsDialogProps {
  open: boolean;
  onClose: () => void;
}
export const TermsAndConditionsDialog: FC<TermsAndConditionsDialogProps> = (props) => {
  const { terms } = useTermsAndConditionsController();
  return (
    <>
      <Dialog open={props.open}>
        <DialogTitle>Terms and Conditions</DialogTitle>
        <DialogContent>
          <Typography variant={'caption'} dangerouslySetInnerHTML={{ __html: terms.content }}></Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose}>Dismiss</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
